import { render, staticRenderFns } from "./OutcomeList.vue?vue&type=template&id=205cf3c0"
import script from "./OutcomeList.js?vue&type=script&lang=js&external"
export * from "./OutcomeList.js?vue&type=script&lang=js&external"
import style0 from "./OutcomeList.vue?vue&type=style&index=0&id=205cf3c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports